// @ts-check
import React from "react"
import ClientProjectChip from "../ClientProjectChip.molecule"
import { isTaskReportItem } from "../../../utils/report.utils"

/**
 * @param {import("./ProjectCodeCell.molecule").ProjectCodeCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */
export function ProjectCodeCell(props) {
  const {
    ctx,
    isHoldingModifierDown,
    onLeftClickClientCode,
    onLeftClickProjectName,
  } = props
  const { row, table, getValue } = ctx
  const projectCode = getValue()
  const rowData = row.original
  const isTask = isTaskReportItem(rowData)

  if (row.getIsGrouped() || !isTask) {
    return null
  }

  return (
    <div className="flex gap-2 align-items-center project-chip-td">
      <ClientProjectChip
        clientCode={rowData.clientCode}
        projectCode={projectCode}
        className={`${isHoldingModifierDown ? "ctrl-selectable-badge" : ""}`}
        onClientClick={() => {
          if (isHoldingModifierDown && rowData.clientCode) {
            onLeftClickClientCode?.(table, rowData.clientCode)
          }
        }}
        onProjectClick={() => {
          if (isHoldingModifierDown && rowData.projectName) {
            onLeftClickProjectName?.(table, rowData.projectName)
          }
        }}
      />
    </div>
  )
}
